
import MobilePreMainComp from "../../components/molbile-prepaid/MobilePreMainComp"

export const MobilePrepaidPage = ({ title_1, title_2, title }) => {
   
    return <div>
        <MobilePreMainComp title_1={title_1} title_2={title_2} title={title} />
    </div>
}